import Axios from "axios";

Axios.defaults.withCredentials = true;

export const localAPI = Axios.create({
  baseURL: process.env.REACT_APP_LOCAL_API_URL
});

localAPI.interceptors.request.use((req) => {
  if (localStorage.getItem("userInfo")) {
    req.headers.Authorization = JSON.parse(
      localStorage.getItem("userInfo")
    ).token;
  }
  return req;
});
